import moment from "moment"
import { API_URL } from "../config/config"
import { deleteRequest, downloadRequest, getRequest, postRequest, putRequest } from "../utils/axiosUtils"
import { formatStoredPhone, getFilterQuery, getStatusLabel } from "../utils/helperFunction"

export const saveNewAdmission = async (values={},setSaving) => {
    if (!values) {
        throw new Error('Admission data is required.')
    }

    let payload = {}
    const keys = Object.keys(values)
    const fieldType = ["universityId","courseNameId","specializationNameId"]
    keys?.forEach(key=>{
        if(typeof values[key]==="object" && fieldType?.includes(key)){
            payload[key] = values[key]?.value
        }else{
            payload[key] = values[key]
        }
    })

    setSaving(true)
    try {
        const response = values?.admissionId ? 
        await putRequest({
            url: `${API_URL}/admission/update/${values?.admissionId}`,
            data: payload,
            headers: {
                'Content-Type': 'application/json'
            },
        })
        : await postRequest({
            url: `${API_URL}/admission/add`,
            data: payload,
            headers: {
                'Content-Type': 'application/json'
            },
        })

        if (response?.data?.success === false) {
            const customError = new Error(response.data.message || 'Validation failed')
            customError.fieldErrors = response.data.errors || {}
            throw customError
        }

        return response.data
    } catch (err) {
        const responseData = err?.response?.data
        if (responseData) {
            const customError = new Error(responseData.message || 'Admission saving failed')
            customError.fieldErrors = responseData.errors || {}
            throw customError
        }

        throw new Error(err.message || 'Unknown error occurred')
    }finally{
    setSaving(false)
    }
}

export const fetchAllAdmissionList = async (
  {
  setRows,
  filterData = {},
  setRowCount,
  setLoading
}) => {
  try {
    setLoading && setLoading(true)
    const query = getFilterQuery(filterData)
    const url = `${API_URL}/admission/all${query}`;

    const response = await getRequest({url});

    if (response.status >= 200 && response.status < 300 && response.data) {
      const pagination = response.data?.pagination
      const options = (response.data?.data || []).map((item,idx) => ({
        sNo: (pagination?.page-1)*pagination.limit + (idx+1),
        id: item._id,
        admissionId:item?._id || "-",
        studentID:item?.studentId || "-",
        fullName:item?.user?.fullName || "-",
        phone: item?.user?.phone ? formatStoredPhone(item?.user?.phone) : '-', 
        email:item?.user?.email || "-",
        university: item?.university?.universityName || '-',
        logo: item?.university?.universityLogo || '-',
        university_ID: item?.university?.universityId || '-',
        course: item?.course?.name || '-',
        specialization: item?.specialization?.name || '-',
        fees: item?.courseFee?.amount ? `${item?.courseFee?.currency?.toUpperCase()} ${(item?.courseFee?.amount)}` : '-',
        feesCurrency: item?.courseFee?.currency || '-',
        paymentType: item?.paymentStatus ? getStatusLabel(item?.paymentStatus)  :  '-',
        receipt: item?.receipt || '-',
        
        enrollmentDate: item.createdAt ? moment(item.createdAt).format("DD/MM/YYYY") : '-',

        universityId: item?.university ? {label:item?.university?.universityName,value:item?.university?._id} :null,
        courseNameId: item?.course ? {label:item?.course?.name,value:item?.course?._id} :null,
        specializationNameId: item?.specialization ? {label:item?.specialization?.name,value:item?.specialization?._id} :null,
        courseFee: item?.courseFee || {},
        paidAmt: item?.paidAmt || {},
        paymentStatus: item?.paymentStatus ||  '-',
      }));

      setRows(options);
      setRowCount && setRowCount(response.data?.pagination?.total || 0)
    } else {
      setRows([])
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("fetchAllAdmissionList error",error);
      setRows([])
     throw new Error(error?.response?.data?.message || 'Unknown error occurred');
  }finally{
    setLoading && setLoading(false)
  }
};

export const downloadAdmissionList = async ({
  setDownloading,
  filterData={}
}) => {
  try {
    const query = getFilterQuery(filterData)
    const url = `${API_URL}/admission/all${query}`

    setDownloading && setDownloading(true)
    const response = await downloadRequest({ url });

    if (response.status >= 200 && response.status < 300 && response.data) {
      const blob = new Blob([response?.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "admission.xlsx";
      link.click();
      window.URL.revokeObjectURL(url);
    } else {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("downloadAdmissionList error", error);
    throw new Error(error?.response?.data?.message || `Failed to download`);
  } finally {
    setDownloading && setDownloading(false)
  }
};


export const deleteAdmissionById = async (
  {
  admissionId,
  setDeleting
}) => {
  try {
    if (!admissionId) {
        throw new Error('Admission ID is required.')
    }
    setDeleting && setDeleting(true)

    const url = `${API_URL}/admission/delete/${admissionId}`;

     await deleteRequest({url});

  } catch (error) {
    console.error("deleteAdmissionById error",error);
     throw new Error(error?.response?.data?.message || 'Unknown error occurred');
  }finally{
    setDeleting && setDeleting(false)
  }
};